export enum TotalWeightLossState {
    none = 'none',
    over75 = 'over-75', // Used for body weight measurements states calculated with OCA distribution
    overMedianPlus1SD = 'overMedianPlus1SD',
    overMedianPlus2SD = 'overMedianPlus2SD',
    under25 = 'under-25', // Used for body weight measurements states calculated with OCA distribution
    underMedianMinus1SD = 'underMedianMinus1SD',
    underMedianMinus2SD = 'underMedianMinus2SD',
}
